import { ActionForm, FormInput } from '@form/index';
import Confirmation from 'components/Confirmation';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
    callback?: () => any;
}

export const Forgot = ({ callback }: Props) => {
    const { t } = useTranslation('auth');
    const [success, setSuccess] = useState(false);

    if (success)
        return (
            <Confirmation
                callback={callback}
                title="Passwort zurücksetzen abgeschlossen"
                message="Wir haben dir eine E-Mail mit einem Link zum Zurücksetzen deines Passworts geschickt. Falls unter der angegebenen E-Mail Adresse kein Account existiert, erhältst du keine E-Mail."
            />
        );

    return (
        <ActionForm url="forgot" onSuccess={() => setSuccess(true)} submitTitle={t('Passwort zurücksetzen')}>
            <FormInput name="email" label="E-Mail Adresse" type="email" required autoFocus />
        </ActionForm>
    );
};
